/**
 * Label Status Enum
 *
 * Defines the possible status values for a standard label
 */
export enum LabelStatus {
  PENDING = 'pending',
  APPROVED = 'approved',
}
